import { environmentFromHost, isQAEnviroment } from 'shared/environment-helpers'
import { isBrazilNeo } from './country'

const environment = environmentFromHost()

const dev = __DEV__
const ca = environment === 'ca'
const be = environment === 'be'
const lu = environment === 'lu'
const es = environment === 'es'
const uk = environment === 'uk'

const countryPurchaseFlow = window.COUNTRY_PURCHASE_FLOW?.toLowerCase()

const isCanadaPurshaseFlow = countryPurchaseFlow === 'ca'
const isBrazilNeoPurchaseFlow = window.COUNTRY?.toLowerCase() === 'br-neo'
const hasDownloadApp = window.SHOW_DOWNLOAD_APP

const qa = isQAEnviroment()

const featureToggles = {
    // business logic
    showCookiePolicy: !!window.SHOW_COOKIE_POLICY,

    // Auth
    newAuthFlow: !!window.USE_THINX_API,
    additionalSignupData: isBrazilNeoPurchaseFlow,
    confirmSignUpEmail: dev || uk || qa || be || lu || es || false,
    requiresPhoneNumberDuringSignUp: isBrazilNeo,

    // Map
    canFilterByVehicleTypes: !isBrazilNeo,

    // Buying
    newSubscriptionFlow: isCanadaPurshaseFlow || isBrazilNeoPurchaseFlow,

    bookingRedirect: isBrazilNeo,

    // if we remove canada subscription flow code, following line will be removed as well
    caPurchaseFlow: isCanadaPurshaseFlow,
    brNeoPurchaseFlow: isBrazilNeoPurchaseFlow,
    newSubscriptionDashboard: isCanadaPurshaseFlow,
    nifRequired: es || false,
    hasPrepaidFlow: !!window.HAS_PREPAID_FLOW,
    supportsDebitCard: !isBrazilNeo,
    hasEventFlow: window.HAS_EVENT_FLOW === 'true' || false,
    hasAirportFlow: window.HAS_AIRPORT_FLOW || false,
    isRenewSubscriptionAlways: isBrazilNeo,
    showAllExceptCanada: !ca,
    hasUpSellFlow: window.HAS_UPSELL_FLOW === 'true' || false,
    has3dsPayment: window.HAS_3DS_PAYMENT === 'true' || false,

    // dev tools
    hasHotModuleReplacement: dev || false,
    hasReduxDevTools: dev || qa || false,

    // address form
    newAddressFormUX: !!window.USE_THINX_API || isBrazilNeo,

    // general
    hasBasket: window.SHOW_BASKET,
    hasBusinessUser: window.SHOW_BUSINESS,
    hasSubscriptionTab: window.SHOW_MONTHLY,
    hasReminders: isBrazilNeo,
    showDownloadApp: hasDownloadApp,
    hasSubcriptionLite: isCanadaPurshaseFlow,
    hasTermAndConditionsNewFlow: window.HAS_NEW_TERMS_COND_FLOW === 'true',
    showNpsSurvey: window.SHOW_NPS_SURVEY === 'true',
    showFlightInfo: window.SHOW_FLIGHT_INFO === 'true',
    hasAdditionalProducts: window.ADDITIONAL_PRODUCTS === 'true',
    hasPIXPurchase: isBrazilNeo && window.HAS_PIX_PURCHASE === 'true',
    hasGuestCheckoutFlow: window.GUEST_CHECKOT_FLOW === 'true',
    showSoldOutProducts: window.SHOW_SOLD_OUT_PRODUCTS === 'true',
    showOnScreenCookieButton: window.HAS_COOKIE_BUTTON === 'true' && window.SHOW_COOKIE_POLICY === 'true',
    enableEditBooking: window.ENABLE_EDIT_BOOKING === 'true',
    displayNonBookableLocationsPrice: window.DISPLAY_NON_BOOKABLE_LOCATIONS_PRICE === 'true',
    showCreditCardAddedPopup: window.SHOW_CREDIT_CARD_ADDED_POPUP === 'true',
}

export default featureToggles
